import { Component } from '@angular/core';
import data from '../../package.json'
import * as moment from 'moment'
import { LanguageService } from './shared/services/language.service';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {

  public title = 'Mi Kiosko';
  public version = data?.version;

  constructor(
    public languageService: LanguageService,
  ){
    
  }

  async ngOnInit(){
    // moment.locale('ES');
    moment.locale(this.languageService.default_lang == "MX" ? 'ES' : this.languageService.default_lang == "US" ? 'EN' : 'ES');
  }

}
